import { array, boolean, number, object, string } from "yup";
/**
 * A yup schema for a link to a External Patient Record on an External System.
 */
export const ExternalPatientLinkSchema = object({
    id: string().uuid().required(),
    patientId: string().uuid().required(),
    // Identifiers for the external system to which we are connected
    externalSystemType: string().required(),
    externalSystemId: string().uuid().required(),
    // Identifiers for the patient record on the external system
    externalPatientIdType: string().required(),
    externalPatientIdValue: array(string().min(1).required()).min(1).required(),
    priorityWithinExternalSystem: number().integer().min(0).required(),
    isInvalid: boolean().required(),
}).required();
// We cannot use yup to infer as it doesn't work for tsoa.
// export type ExternalPatientLink = InferType<typeof ExternalPatientLinkSchema>;
// But we can use ObjectSchema<> to ensure they largely stay in sync
//# sourceMappingURL=externalPatientLink.js.map